<template>
	<div class="page">
		<!--  企业工作室  -->
		<div class="app-container">
			<el-row>
				<el-col :span="6" class="left-content">
					<el-row class="left-top-content">
						<div class="left-top-content-title">
							<el-col :span="12" style="text-align: left;color: #FFFFFF;font-size: 0.8125rem;">
								<span>{{timeDate}}</span>
							</el-col>
							<el-col :span="12" style="text-align: right;color: #fcff44;font-size: 0.8125rem;">
								<span class="qyrz">{{ftype == '1' ? '已认证用户' : isQyrz ? '已认证企业':'未认证企业'}}</span>
							</el-col>
						</div>
					</el-row>
					<el-row class="left-bottom-content">
						<el-col :span="10" class="left-bottom-content-left">
							<el-row>
								<span class="left-bottom-content-left-year">
									{{ parseTime(new Date(), '{y}')  }}年
								</span>
							</el-row>
							<el-row :gutter="20" class="left-bottom-content-left-row2">
								<el-col :span="12" style="background-color: #f6f6f6;height: 4.5rem;">
									<span class="left-bottom-content-left-content-left">
										{{ parseTime(new Date(), '{d}')  }}
									</span>
								</el-col>
								<el-col :span="12">
									<span class="left-bottom-content-left-content-right">
										{{ parseTime(new Date(), '{m}')  }}月
									</span>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24">
									<span class="left-bottom-content-left-row3">
										{{weekday}}
									</span>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="14" class="right-content">
							<el-row class="right-content-row-1">
								<el-col :span="24">{{getTimeState()}} {{realName}}</el-col>
							</el-row>
							<el-row>
								<el-col :span="24" class="right-content-row-1-title">
									<span v-if="ftype == '2'">认证企业：</span>
									<span v-else>认证用户：</span>
									<br />
									<span class="right-content-row-1-title-2">{{entname}}</span>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24" class="right-content-row-1-title">
									<span>登录时间：</span>
									<br />
									<span class="right-content-row-1-title-2">{{ entTime }}</span>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24" class="right-content-row-1-title-logout">
									<el-button style="width: 8.5rem;letter-spacing:0.9rem;padding-left: 2rem"
										type="danger" size="mini" @click="logout">退出</el-button>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
					<el-row class="menu-box">
						<el-col :span="24">
							<div v-for="item in menuList" style="text-align: left;margin-top: 1.25rem;">
								<template v-if="ftype == '1'">
									<!-- 个人 -->
									<template v-if="item.title == '发布' || item.title == '我的收藏' || item.title == '消息中心'">
										<img src="../../assets/images/qygzs/4.png" style="margin-right: 0.3125rem" />
										<span style="font-weight: 600;color: #1482F0;">
											{{item.title}}
										</span>
										<el-divider></el-divider>
										<el-row>
											<el-col :span="12" v-for="data in item.menuNameList"
												style="text-align: left;margin-top: 0.625rem;">
												<template
													v-if="data.code == 'zlzrfb' || data.code == 'scxxcx'
													|| data.code == 'tsflfgzc' || data.code == 'tszn' || data.code == 'tsxx'">
													<span style="cursor: pointer;" @click="menuFun(data.code)"
														:class="{'menu-active':activeCode==data.code}">
														{{data.menuName}}
													</span>
												</template>
											</el-col>
										</el-row>
									</template>
								</template>
								<template v-else>
									<!-- 企业 -->
									<img src="../../assets/images/qygzs/4.png" style="margin-right: 0.3125rem" />
									<span style="font-weight: 600;color: #1482F0;">
										{{item.title}}
									</span>
									<el-divider></el-divider>
									<el-row>
										<el-col :span="12" v-for="data in item.menuNameList"
											style="text-align: left;margin-top: 0.625rem;">
											<span style="cursor: pointer;" @click="menuFun(data.code)"
												:class="{'menu-active':activeCode==data.code}">
												{{data.menuName}}
											</span>
										</el-col>
									</el-row>
								</template>
							</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="18" class="right-box">
					<el-row style="margin-left: 1.25rem;margin-bottom: 1.25rem;">
						<el-col :span="7" style="height: 13.75rem;padding-right: 0.6rem;">
							<el-row class="yfbclass">
								<el-col :span="24">
									<span>已发布</span>
								</el-col>
							</el-row>
							<el-row class="yfbnum">
								<el-col :span="8" class="yfbbackground" style="height: 100%;">
									<el-row>
										<el-col :span="24" class="yfbbackgroundtitle">
											<span>单位：条</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24" class="yfbbackgroundnum">
											<span>{{zlzrnum}}</span>
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="8" class="yfbbackground" style="height: 100%;margin: 0.4375rem 0.5rem;">
									<el-row>
										<el-col :span="24" class="yfbbackgroundtitle">
											<span>单位：条</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24" class="yfbbackgroundnum">
											<span>{{rzfwcpnum}}</span>
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="8" class="yfbbackground" style="height: 100%;">
									<el-row>
										<el-col :span="24" class="yfbbackgroundtitle">
											<span>单位：条</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24" class="yfbbackgroundnum">
											<span>{{zpxxnum}}</span>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
							<el-row style="height: 25%;">
								<el-col :span="8" class="yfbtitle" style="height: 100%;">
									<span>专利转让</span>
								</el-col>
								<el-col :span="8" class="yfbtitle" style="height: 100%;margin: 0 0.5rem;">
									<span>融资服务</span>
								</el-col>
								<el-col :span="8" class="yfbtitle" style="height: 100%;">
									<span>招聘信息</span>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="7" style="height: 13.75rem;padding-left: 0.625rem;">
							<el-row style="height: 100%;">
								<el-col :span="11" style="height: 100%;">
									<el-row class="ywclass-1">
										<el-col :span="24">
											<span>已咨询</span>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24" class="ywclassback-1">
											<el-row>
												<el-col :span="24" class="ywzxbackgroundtitle">
													<span>单位：条</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ywzxbackgroundnum">
													<span>{{ywzxnum}}</span>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
									<el-row class="ywclass-1-2">
										<el-col :span="24">
											业务咨询
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="13" style="height: 100%;">
									<el-row class="ywclass-2">
										<el-col :span="24">
											<span>已申请/申办</span>
										</el-col>
									</el-row>
									<el-row class="ywsqclass">
										<el-col :span="24">
											<el-row>
												<el-col :span="24" class="ywsqbackgroundtitle">
													<span>单位：条</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ywsqbackgroundnum">
													<span>{{ywsqnum}}</span>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
									<el-row class="ywclass-2-2">
										<el-col :span="24">
											业务申请/申办
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="10" style="height: 13.75rem">
							<el-row style="height: 100%;background-color: #afb076;padding: 1rem;">
								<el-col :span="10" style="height: 100%;">
									<el-row class="four-left" style="height: 45%;padding:0 0.3125rem 0.3125rem 0;">
										<el-col :span="12">
											<el-row>
												<el-col :span="24" class="yscnumclass">
													<span>{{yscnum}}</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ysctitleclass">
													<span>已收藏</span>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="12" style="float: right;padding-top: 0.6875rem">
											<img src="../../assets/images/qygzs/8.png" />
										</el-col>
									</el-row>
									<el-row class="four-left"
										style="height: 45%;margin-top:10% ;padding-right:0.3125rem;">
										<el-col :span="12">
											<el-row>
												<el-col :span="24" class="yscnumclass">
													<span>{{drxxnum}}</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ysctitleclass">
													<span>当日消息</span>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="12" style="float: right;padding-top: 0.6875rem">
											<img src="../../assets/images/qygzs/9.png" />
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="14" style="height: 100%;">
									<el-row class="four-right" style="height: 45%;margin-left: 0.625rem;">
										<el-col :span="12">
											<el-row>
												<el-col :span="24" class="yscnumclass-1">
													<span>{{flfgzcnum}}</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ysctitleclass-1">
													<span>当日政策法规</span>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="12" style="float: right;padding-top: 0.6875rem">
											<img src="../../assets/images/qygzs/10.png" />
										</el-col>
									</el-row>
									<el-row class="four-right" style="height: 45%;margin:1rem 0 0 0.625rem;">
										<el-col :span="12">
											<el-row>
												<el-col :span="24" class="yscnumclass">
													<span>{{drtsznnum}}</span>
												</el-col>
											</el-row>
											<el-row>
												<el-col :span="24" class="ysctitleclass">
													<span>当日办事指南</span>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="12" style="float: right;padding-top: 0.6875rem">
											<img src="../../assets/images/qygzs/11.png" />
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
					<el-row class="right-box-content" :style="'min-height:'+(activeRight=='1'?'55.5rem':'40.315rem')">

						<el-col :span="24" v-if="!isQyxxWS && ftype==='2' " style="padding-top: 10rem;">
							<img src="../../assets/images/qygzs/15.png" />
							<div>
								<span>您尚未完善信息，请尽快完善!否则将会影响您使用本平台！</span>
								<span class="ljwsclass" @click="ljwsFun">立即完善</span>
							</div>
						</el-col>
						<el-col :span="24" v-if="isQyxxWS && ftype==='2'  " >
							<div align="left">
<!--								<span class="ljwsclass" @click="ljwsFunTwo" title="再次修改完善平台基本信息">>>>修改基础信息</span>-->
								<el-button type="primary" plain  @click="ljwsFunTwo" title="再次修改完善平台基础信息">>>修改基础信息</el-button>
							</div>
						</el-col>
						<el-col :span="24" v-if="ftype==='1' " >
							<div align="left">
<!--								<span class="ljwsclass" @click="ljwsFunGr" title="再次修改完善平台基本信息">>>>修改基础信息</span>-->
								<el-button type="primary" plain  @click="ljwsFunGr" title="再次修改完善平台基础信息">>>修改基础信息</el-button>
<!--								<span>完善个人信息</span>-->
							</div>
						</el-col><br><br>
						<component :is="currentView" :pripid="pripid" :entname="entname" :uniscid="uniscid"></component>
					</el-row>

				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	import "@/assets/styles/mainindex/iconfont.css";
	import wsqyxx from "./wsQyxx";
	import wsgrxx from "./wsGrxx";
	import zlg from "./zlg";
	import zxclcx from "./zxclcx";
	import tsflfgzc from "./tsflfgzc";
	import tszn from "./tszn";
	import tsxx from "./tsxx";
	import scxxcx from "./scxxcx";
	import sbsxcx from "./sbsxcx";
	import kjjl from "./kjjl";
  import fbgx from "@/views/main/fbgx"
	//一企一档
	import QydjJbxx from "@/views/qygzs/yqyd/qy/QydjJbxx";
	import NbQyJbxx from "@/views/qygzs/yqyd/qy/NbQyJbxx";
	import QyXkxx from "@/views/qygzs/yqyd/qy/QyXkxx";
	import Jgxx from "@/views/qygzs/yqyd/qy/Jgxx";
	import Ycmlxx from "@/views/qygzs/yqyd/qy/Ycmlxx";
	import Yzwfqyxx from "@/views/qygzs/yqyd/qy/Yzwfqyxx";
	import GtdjJbxx from "@/views/qygzs/yqyd/gt/GtdjJbxx";
	import GtXkxx from "@/views/qygzs/yqyd/gt/GtXkxx";
	import NbGtJbxx from "@/views/qygzs/yqyd/gt/NbGtJbxx";
	import {getFwjg,} from "@/api/fwjg/fwjg";
	import {
		getLogout,
		getLoginUserValidate
	} from "@/api/index";
	import { logout as doLogout } from "@/utils/yawei";
	import {
		updatePvNum
	} from "@/api/itempv/pv";
	import {
		getTotal
	} from "@/api/qygzs/index";
  import tzsbyy from "../main/tzsbyy.vue";
  import cccmblink from "../main/cccmblink.vue";
  import zlkflink from "../main/zlkflink.vue";
  import zyrzlink from "../main/zyrzlink.vue";
  import ppjslink from "../main/ppjslink.vue";
  import tzsbksslink from "../main/tzsbksslink.vue";
	export default {
		//企业工作室
		name: 'QygzsIndex',
		components: {
			wsqyxx,
			wsgrxx,
			zlg,
			zxclcx,
			tsflfgzc,
			tszn,
			tsxx,
			scxxcx,
			sbsxcx,
			kjjl,
			QydjJbxx,
			NbQyJbxx,
			QyXkxx,
			Jgxx,
			Ycmlxx,
			Yzwfqyxx,
			GtdjJbxx,
			GtXkxx,
			NbGtJbxx,
      fbgx,
      tzsbyy,
      cccmblink,
      zlkflink,
      zyrzlink,
      ppjslink,
      tzsbksslink
		},
		data() {
			return {
				searchParam: {
					type: undefined,
					content: undefined
				},
				islogin: true,
				timeDate: undefined,
				timer: undefined,
				isQyrz: true,
				weekday: undefined,
				realName: '',
				entTime: undefined,
				menuList: [{
						title: '发布',
						menuNameList: [{
								code: 'zlzrfb',
								menuName: '专利转让发布'
							},
							{
								code: 'zpxxfb',
								menuName: '招聘信息发布'
							},
							{
								code: 'kjjl',
								menuName: '企业服务/需求发布'
							},
						],
					},
					{
						title: '质量官管理',
						menuNameList: [{
							code: 'zlg',
							menuName: '质量官'
						}]
					},
					{
						title: '企业咨询管理',
						menuNameList: [{
								code: 'fqzx',
								menuName: '发起咨询'
							},
							{
								code: 'zxclcx',
								menuName: '咨询处理查询'
							},
						],
					},
					{
						title: '申办事项管理',
						menuNameList: [{
							code: 'sbsxcx',
							menuName: '申办事项查询'
						}]
					},
					{
						title: '我的收藏',
						menuNameList: [{
							code: 'scxxcx',
							menuName: '收藏信息查询'
						}]
					},
					{
						title: '消息中心',
						menuNameList: [{
								code: 'tsflfgzc',
								menuName: '推送法律法规政策'
							},
							{
								code: 'tszn',
								menuName: '推送指南'
							},
							{
								code: 'tsxx',
								menuName: '推送消息'
							},
						],
					},
          {
            title: '质量基础设施服务专区',
            menuNameList: [{
              code: 'fbgx',
              menuName: '发布供需'
            }]
          },
          {
            title: '其他',
            menuNameList: [
                {
              code: 'tzsbyy',
              menuName: '特种设备预约链接'
            },
              {
                code: 'cccmblink',
                menuName: 'CCC免办链接'
              },
              {
                code: 'zlkflink',
                menuName: '专利开放许可登记链接'
              },
              {
                code: 'zyrzlink',
                menuName: '质押融资贴息申报链接'
              },
              {
                code: 'ppjslink',
                menuName: '品牌建设申报链接'
              },
              {
                code: 'tzsbksslink',
                menuName: '特种设备考试预约链接'
              }
            ]
          },
				],
				zlzrnum: 0,
				rzfwcpnum: 0,
				zpxxnum: 0,
				ywzxnum: 0,
				ywsqnum: 0,
				yscnum: 0,
				drxxnum: 0,
				flfgzcnum: 0,
				drtsznnum: 0,
				isJbxx: true, //是否显示基本信息
				activeCode: 'jbxx',
				//是否已经完善企业信息，默认否
				isQyxxWS: false, //false 未完善  true已完善
				activeRight: '0',
				currentView: undefined,
				ftype: '',
				//企业主体身份代码，一企一档中企业基础信息等内容通过这个字段进行关联展示
				pripid: undefined,
				//企业统一社会信用代码，一企一档中监管信息许可信息等内容通过这个字段或联合企业名称 entname 进行关联展示
				uniscid: '',
				//企业统一社会信用代码，一企一档中监管信息许可信息等内容通过这个字段或联合企业名称 entname 进行关联展示
				entname: '',
				/* 企业类别:1 企业 2 个体 默认企业 */
				entcat: '1',
			}
		},
		activated() {},
		deactivated() {},
		created() {
			this.checkLoginUser();
			updatePvNum("qygzs").then(response => {
				//pv 点击企业工作室
			});

			this.weekday = "星期" + "日一二三四五六".charAt(new Date().getDay());
			this.entTime = this.parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}');


			/* this.getlocalStorage(); */
			/* 	setTimeout(function() {
					// this.clearLocalStorage();
				}, 5000); */
		},
		mounted() {
			let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
			this.timer = setInterval(() => {
				_this.timeDate = this.parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}'); // 修改数据date
			}, 1000)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		methods: {
			checkLoginUser() {
        let ssessionLoginUser = {"token":"8c0ea4d4dc7a681ec6e9c068f92729ed","loginTime":1743064817710,"expireTime":1743066617710,"ipaddr":null,"loginLocation":null,"browser":null,"os":null,"permissions":null,"user":{"uuid":"142767912","realName":"孙平","isauthuser":"1","cartType":"111","cartId":"370633197012261327","tel":"13001658539","ftype":"2","corname":"威海顺通会计服务有限公司","cornumber":"91371000MA95018D8K","state":0,"isBlackList":"N","isWhEnt":"Y","finishedInfo":"Y","county":"371020","countyCh":"高区","ywFwjgRecid":"7446522257fa445fb8d52fa7b93b1595"},"ywFwjg":{"recid":"7446522257fa445fb8d52fa7b93b1595","pripid":"3710000000220210924BTTFG","name":"威海顺通会计服务有限公司","uniscid":"91371000MA95018D8K","dom":"乳山市大孤山镇吴家沟村","llr":"李四666","llrtel":"15311432453","llrphone":"86237928","type":"00350087310f439daa96aa3025a6c06d","fwlmStatus":"1","shStatus":"2","zcTime":null,"deleteStatus":"N","synopsis":"asdfdsaf","website":null,"createBy":null,"createTime":"2021-11-20 00:00:00","updateBy":"孔霞","updateTime":"2023-02-09 00:00:00","zcsjStartTime":null,"zcsjEntTime":null,"cxReason":null,"userType":"2","loginName":"威海顺通会计服务有限公司","uuid":"142767912","lastLoginTime":null,"isBlack":"N","loginStatus":"1","loginTime":1743064817759,"county":"371020","countyCh":"高区","deptId":51,"deptCode":"37100031","cardType":null,"cardNumber":null,"entcat":"1","isFinishEdInfo":null,"opIdea":null,"ywAuditStatus":"4","ywSaveStatus":"Y","ywDelStatus":"N"},"enabled":true,"islogin":true}
				// let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
        let ssessionLogin = ssessionLoginUser
				// console.log("qygzs index   ssessionLoginUser==",ssessionLogin);
				this.entname = ssessionLogin.ywFwjg.name || ssessionLogin.user.corname;
				// console.log("user==>",ssessionLogin.user);
				// console.log("ywFwjg==>", ssessionLogin.ywFwjg);
				this.uniscid = ssessionLogin.ywFwjg.uniscid;
				this.pripid = ssessionLogin.ywFwjg.pripid;
				this.ftype = ssessionLogin.user.ftype;
				this.entcat = ssessionLogin.ywFwjg.entcat;
				this.constructMenu(this.entcat);
				getFwjg(ssessionLogin.ywFwjg.recid).then(response => {
					// debugger
					let ywFwjgObj = response.data;
					let userType = ywFwjgObj.userType;//用户类型
					// debugger
					if(userType ==='1'){
						//个人
						if(ywFwjgObj.llrtel === null || ywFwjgObj.llrtel==='' || ywFwjgObj.llrtel===undefined){
							this.isQyxxWS = false;
						}else if(ywFwjgObj.county === null || ywFwjgObj.county==='' || ywFwjgObj.county===undefined){
							this.isQyxxWS = false;
						}else{
							this.isQyxxWS = true;
							this.currentView = 'wsgrxx';
						}
					}else{
						//企业用户
						if(ywFwjgObj.type === null || ywFwjgObj.type==='' || ywFwjgObj.type===undefined){
							this.isQyxxWS = false;
						}else if(ywFwjgObj.county === null || ywFwjgObj.county==='' || ywFwjgObj.county===undefined){
							this.isQyxxWS = false;
						}else{
							this.isQyxxWS = true;
							this.currentView = 'QydjJbxx';
							if (ywFwjgObj.entcat === '2'){//如果当前用户是个体，显示个体基础信息
								this.currentView = 'GtdjJbxx';
							}
						}
					}
				});
				//是否已经完善企业信息
				// console.log("1111111111111",ssessionLogin.ywFwjg);
				// this.isQyxxWS = this.isEmptyStr(ssessionLogin.ywFwjg.type) ? false : true;
				// //已经完善了企业信息
				// if (this.isQyxxWS && this.ftype==='2') {
				// 	//默认显示企业基础信息
				// 	this.currentView = 'QydjJbxx';
				// 	if (this.entcat === '2')//如果当前用户是个体，显示个体基础信息
				// 		this.currentView = 'GtdjJbxx';
				// }else if (this.isQyxxWS && this.ftype==='1'){
				// 	this.currentView = 'wsgrxx';
				// }
				if (this.ftype === '1') {
					this.realName = '个人用户';
					this.isJbxx = false;
					//个人用户，企业完善信息不显示
					// this.isQyxxWS = true;
					this.activeCode = '';
					this.currentView = 'wsgrxx';

				} else {
					this.realName = '企业用户';
					// console.log("num*****==>", ssessionLogin.user);
					getTotal(ssessionLogin.user.ywFwjgRecid).then(response => {
						this.zlzrnum = response.zlzrfb;
						this.rzfwcpnum = response.xwqyrzsq;
						this.zpxxnum = response.qyzpxx;
						this.ywzxnum = response.zxzx;
						this.ywsqnum = response.sqsb;
						this.yscnum = response.sc;
						this.drxxnum = response.nowSms;
						this.flfgzcnum = response.flfg;
						this.drtsznnum = response.bszn;

					});
				}

			},
			login() {
				this.islogin = true;
			},
			logout() {
				let ywFwjgRecid = JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
				this.$confirm(
					'是否确认退出?',
					'系统提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning'
					}
				).then(() => {
					doLogout(ywFwjgRecid);
				});

			},
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},
			getTimeState() {
				// 获取当前时间
				let timeNow = new Date();
				// 获取当前小时
				let hours = timeNow.getHours();
				// 设置默认文字
				let state = ``;
				// 判断当前时间段
				if (hours >= 0 && hours <= 10) {
					state = `早上好!`;
				} else if (hours > 10 && hours <= 14) {
					state = `中午好!`;
				} else if (hours > 14 && hours <= 18) {
					state = `下午好!`;
				} else if (hours > 18 && hours <= 24) {
					state = `晚上好!`;
				}
				return state;
			},
			menuFun(code) {
				if (!this.isQyxxWS) {
					this.msgWarning("请先完善企业基本信息！");
					return false;
				}
				if (code === 'zlzrfb') {
					this.utils.windowOpen('/main/zscqzhfw/zscqcsRecord');
				}
				if (code === 'zpxxfb') {
					this.utils.windowOpen('/main/xwqyczfw/zpxqfbForm');
				}
				if (code === 'fqzx') {
					this.utils.windowOpen('/main/zxzxForm');
				}
				this.activeCode = code;
				if (code !== 'jbxx') {
					this.isJbxx = false;
					this.activeRight = '1';
				} else {
					this.isJbxx = true;
					this.activeRight = '0';
				}
				this.currentView = code;
			},
			constructMenu(entcat) {
				let menuYqyd = [{
					title: '一企一档',
					menuNameList: [{
							code: 'QydjJbxx',
							menuName: '基础信息'
						},
						{
							code: 'QyXkxx',
							menuName: '许可信息'
						},
						{
							code: 'Jgxx',
							menuName: '监管信息'
						},
						{
							code: 'NbQyJbxx',
							menuName: '年报信息'
						},
						{
							code: 'Ycmlxx',
							menuName: '异常名录信息'
						},
						{
							code: 'Yzwfqyxx',
							menuName: '严重违法信息'
						}
					]
				}];
				if (entcat === '2') {
					menuYqyd = [{
						title: '一企一档',
						menuNameList: [{
								code: 'GtdjJbxx',
								menuName: '基础信息'
							},
							{
								code: 'GtXkxx',
								menuName: '许可信息'
							},
							{
								code: 'Jgxx',
								menuName: '监管信息'
							},
							{
								code: 'NbGtJbxx',
								menuName: '年报信息'
							},
							{
								code: 'Ycmlxx',
								menuName: '异常名录信息'
							},
							{
								code: 'Yzwfqyxx',
								menuName: '严重违法信息'
							}
						]
					}];
				}
				this.menuList = [...menuYqyd, ...this.menuList];


			},
			ljwsFun() {
				this.isQyxxWS = !this.isQyxxWS;
				this.currentView = 'wsqyxx';
			},
			ljwsFunTwo() {
				// this.isQyxxWS = !this.isQyxxWS;
				this.currentView = 'wsqyxx';
			},
			ljwsFunGr(){
				this.currentView = 'wsgrxx';
			},
			getlocalStorage() {
				const en = JSON.parse(localStorage.getItem('qygzs_menu'));
				if (en != undefined && en != "") {
					this.menuFun(en);
				}
			},
			clearlocalStorage() {
				localStorage.removeItem("qygzs_menu");
			}
		}
	}
</script>
<style scoped>
	.app-container {
		padding: 5px 15px 30px;
		background-color: #ffffff;
	}

	.left-content {
		background-image: url('../../assets/images/qygzs/1.png');
	}

	.right-content {
		height: 14.0625rem;
		position: absolute;
		right: 0;
		padding: 0.5rem 0.625rem 0 1.875rem;
	}

	.left-top-content {
		padding: 0.625rem;
	}

	.left-bottom-content-left {
		position: absolute;
		width: 8.625rem;
		height: 10.4375rem;
		background-image: url('../../assets/images/qygzs/2.png');
		left: 0.625rem;
		top: 0.625rem;
		padding: 0.625rem;
	}

	.left-bottom-content-left-year {
		font-size: 1.125rem;
		color: #FFFFFF;
		font-weight: 600;
	}

	.left-bottom-content-left-row2 {
		min-height: 4.8rem;
		padding: 0.9375rem 0 0.2rem 0.9375rem;
	}

	.left-bottom-content-left-content-left {
		font-size: 2.5rem;
		color: #000000;
		text-align: center;
		line-height: 4.5rem;
	}

	.left-bottom-content-left-content-right {
		font-size: 1.125rem;
		color: #000000;
		font-weight: 800;
		line-height: 4.5rem;
	}

	.left-bottom-content-left-row3 {
		font-size: 1.125rem;
		color: #000000;
		font-weight: 800;
	}

	.right-content-row-1 {
		font-size: 1rem;
		text-align: left;
		color: #FFFFFF;
	}

	.right-content-row-1-title {
		font-size: 0.8125rem;
		color: #ffaa00;
		text-align: left;
		margin-top: 0.5rem;
	}

	.right-content-row-1-title-logout {
		font-size: 0.8125rem;
		color: #ffaa00;
		text-align: left;
		margin-top: 0.5rem;
	}

	.right-content-row-1-title-2 {
		text-align: left;
		color: #FFFFFF;
		margin-top: 0.3125rem;
		font-size: 0.20rem;
	}

	.menu-box {
		margin-top: 11.5rem;
		min-height: 15rem;
		background-color: #FAFAFA;
		padding: 0 15px 10px 15px;
	}

	.el-divider--horizontal {
		margin: 0.625rem 0;
	}

	.yfbbackground {
		width: 5.125rem;
		height: 6.25rem;
		background-image: url('../../assets/images/qygzs/3.png');
		margin: 0.4375rem 0;
		background-size: cover;
	}

	.yfbclass {
		background-color: #77acb0;
		height: 25%;
		line-height: 3.4375rem;
		color: #FFFFFF;
		font-size: 1.25rem;
		font-weight: 900;
	}

	.yfbnum {
		height: 45.5%;
	}

	.yfbtitle {
		color: #FFFFFF;
		font-size: 0.8125rem;
		width: 5.125rem;
		background-color: #77acb0;
		line-height: 3.4375rem;
	}

	.yfbbackgroundtitle {
		text-align: left;
		padding: 0.3125rem;
		color: #83b4b8;
	}

	.ywzxbackgroundtitle {
		text-align: left;
		padding: 0.3125rem;
		color: #83b4b8;
	}

	.ywsqbackgroundtitle {
		text-align: left;
		padding: 0.3125rem;
		color: #83b4b8;
	}

	.yfbbackgroundnum {
		line-height: 4.1375rem;
		font-size: 2.5rem;
		font-weight: 900;
		color: #669396;
	}

	.ywzxbackgroundnum {
		line-height: 4.1375rem;
		font-size: 2.5rem;
		font-weight: 900;
		color: #76b185;
	}

	.ywsqbackgroundnum {
		line-height: 4.1375rem;
		font-size: 2.5rem;
		font-weight: 900;
		color: #8eb275;
	}

	.ywclass-1 {
		background-color: #76b185;
		height: 25%;
		line-height: 3.4375rem;
		color: #FFFFFF;
		font-size: 1.25rem;
		font-weight: 900;
		width: 6.3125rem;
	}

	.ywclass-2 {
		background-color: #8eb275;
		height: 25%;
		width: 7.875rem;
		line-height: 3.4375rem;
		color: #FFFFFF;
		font-size: 1.25rem;
		font-weight: 900;
	}

	.ywclass-1-2 {
		color: #FFFFFF;
		font-size: 0.8125rem;
		width: 6.3125rem;
		background-color: #76b185;
		line-height: 3.4375rem;
		margin-right: 0.625rem;
	}

	.ywclass-2-2 {
		color: #FFFFFF;
		font-size: 0.8125rem;
		width: 7.875rem;
		background-color: #8eb275;
		line-height: 3.4375rem;
	}

	.ywclassback-1 {
		height: 6.25rem;
		width: 6.3125rem;
		background-image: url('../../assets/images/qygzs/5.png');
		margin: 0.4375rem 0;
	}

	.ywsqclass {
		background-color: #bb4679;
		width: 7.875rem;
		height: 6.25rem;
		background-image: url('../../assets/images/qygzs/6.png');
		margin: 0.4375rem 0;
	}

	.four-left {
		background-image: url('../../assets/images/qygzs/7.png');
		background-size: cover;
	}

	.yscnumclass {
		line-height: 3.4375rem;
		font-size: 2.5rem;
		color: #000000;
		font-weight: 900;
	}

	.ysctitleclass {
		color: #999a61;
		font-size: 0.8125rem;
		font-weight: bold;
	}

	.four-right {
		background-image: url('../../assets/images/qygzs/7.png');
		background-size: cover;
	}

	.yscnumclass-1 {
		line-height: 3rem;
		font-size: 2.5rem;
		color: #000000;
		font-weight: 900;
	}

	.ysctitleclass-1 {
		color: #999a61;
		font-weight: bold;
		font-size: 0.8125rem;
	}

	.right-box-content {
		border: 1px solid #cccccc;
		padding: 10px 15px 0;
		margin-left: 1.25rem;
		/* min-height: 40.315rem; */
	}

	.menu-active {
		color: #ffaa00;
	}

	.ljwsclass {
		color: #ffa407;
		cursor: pointer;
	}

	.jbxx-title {
		color: #409EFF;
		font-size: 1.25rem;
		font-weight: 700;
		margin-bottom: 0.625rem;
		text-align: left;
	}

	.entanme-title {
		background-color: #ebebeb;
		text-align: left;
		min-height: 30px;
		line-height: 1.875rem;
		padding: 0.625rem;
		margin-bottom: 1rem;
	}

	.entname {
		font-size: 18px;
		font-weight: 700;
	}

	.menu-active-right {
		min-height: 45rem;
	}
</style>
